import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';

export default function ExternalLogin({ externalLoginInfoPath }) {
  const [url, setUrl] = useState();

  useEffect(() => {
    fetch(externalLoginInfoPath)
      .then(res => res.json())
      .then(data => setUrl(data.url));
  }, []);

  return (
    <div className="text-center">
      <p>Sign in or Sign up with the Newmark Investor Marketplace to access this document</p>
      <Button href={url}>Access with NIM</Button>
    </div>
  );
}

ExternalLogin.propTypes = {
  externalLoginInfoPath: PropTypes.string.isRequired
};
